import {Page} from "../pagination/Page";
import axiosInstance from "../network/AxiosInstance";
import {TargetPlaylistItemDTO} from "../models/TargetPlaylistItemDTO";

export class PlaylistService {
    static async allPagedWithPublicTargetPlaylist(
        title: string,
        artist: string,
        album: string,
        url: string,
        probability: string,
        itemGroup: string,
        dateCreated: string | undefined | null,
        page: number,
        size: number,
        sort: string
    ): Promise<Page<any>> {
        const params = new URLSearchParams({
            page: page.toString(),
            size: size.toString(),
        });

        if (title) params.append('title', title);
        if (artist) params.append('artist', artist);
        if (album) params.append('album', album);
        if (url) params.append('url', url);
        if (probability) params.append('probability', probability);
        if (itemGroup) params.append('group', itemGroup);
        if (dateCreated) params.append('dateImported', dateCreated);
        if (sort) params.append('sort', sort);

        const request = { params };

        const response = await axiosInstance.get<Page<TargetPlaylistItemDTO>>(
            `/rest/playlists/target-playlist-item/all-paged-with-public-target-playlist`, request
        );

        const data = response.data;

        return new Page<TargetPlaylistItemDTO>(
            data.content.map(targetPlaylistItem => new TargetPlaylistItemDTO(targetPlaylistItem)),
            data.totalElements
        );
    }
}
